module.exports = __webpack_public_path__ + "img/bee-7666216_1280.2085c804.jpg";